import script from "./foot-qr.vue?vue&type=script&lang=ts&setup=true"
export * from "./foot-qr.vue?vue&type=script&lang=ts&setup=true"

import "./foot-qr.vue?vue&type=style&index=0&id=de1bc1d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1bc1d2"]])

export default __exports__